export default __webpack_public_path__ + "static/w8-7771c56473189f27a22783c0d406f427.webp";